import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PageLayout } from '@cvx/nextpage';
import { UserAccess } from 'src/app/models/user-access.model';
import { AuthAPIMService } from 'src/app/services/authAPIMService/authAPIM.service';
import { UserAccessSvc } from 'src/app/services/userAccess/userAccess.service';

@Component({
  selector: 'user-access',
  templateUrl: './userAccess.component.html',
  styleUrls: ['./userAccess.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class UserAccessComponent implements OnInit {
  PageLayout = PageLayout;

  searchEmail: string = '';
  selectedRegion: 'NA' | 'East' = 'NA';
  result: UserAccess | null = null;
  notFound: boolean = false;
  isAdmin: boolean = false;
  loading: boolean = false;
  error: string | null = null;

  constructor(private authService: AuthAPIMService, private userAccessSvc: UserAccessSvc) {}

  ngOnInit(): void {
    this.isAdmin = this.authService.roles.includes('Library.Admin');
    const currentEmail = this.authService.email;
    if (currentEmail) {
      this.searchEmail = currentEmail;
      this.search();
    }
  }

  search(): void {
    const email = this.isAdmin ? this.searchEmail.trim() : this.authService.email;
    if (!email) {
      this.result = null;
      this.notFound = false;
      this.error = null;
      return;
    }

    this.loading = true;
    this.result = null;
    this.notFound = false;
    this.error = null;

    this.userAccessSvc.getUserSecTypes(email, this.selectedRegion).subscribe({
      next: (permissions) => {
        this.loading = false;
        if (permissions && permissions.length > 0) {
          const sorted = [...permissions].sort((a, b) => a.securityType.localeCompare(b.securityType));
          this.result = { email, groups: sorted };
          this.notFound = false;
        } else {
          this.result = null;
          this.notFound = true;
        }
      },
      error: (err) => {
        this.loading = false;
        this.result = null;
        if (err.status === 404) {
          this.notFound = true;
        } else {
          this.error = 'Failed to retrieve access information. Please try again.';
          console.error('getUserSecTypes error', err);
        }
      }
    });
  }

  clear(): void {
    this.searchEmail = '';
    this.result = null;
    this.notFound = false;
    this.error = null;
  }
}


